// Ein <button>, kein <div onClick>. `type` steht ohne Angabe auf 'button': in einem Formular ist
// die Vorgabe des Browsers 'submit', und ein Abbrechen-Knopf, der absendet, bewegt hier Geld.
import type { ReactElement, ReactNode } from 'react'
import './bausteine.css'

/** primaer: gefüllt, schließt den Vorgang ab · zweit: umrandet, eine weitere Möglichkeit ·
 *  warnung: umrandet in --alert · still: nur Text. */
export type KnopfVariante = 'primaer' | 'zweit' | 'still' | 'warnung'

export interface KnopfProps {
  variante?: KnopfVariante
  type?: 'button' | 'submit'
  onClick?: () => void
  disabled?: boolean
  /**
   * Zieht den Anfangsfokus eines Dialogs auf diesen Knopf (siehe useFokusfalle). Gehört an den
   * harmlosen Ausweg — „Abbrechen“ —, nie an den Knopf, der die unumkehrbare Sache tut.
   */
  erstfokus?: boolean
  children: ReactNode
}

export function Knopf({
  variante = 'primaer',
  type = 'button',
  onClick,
  disabled = false,
  erstfokus = false,
  children,
}: KnopfProps): ReactElement {
  return (
    <button
      className="knopf"
      data-variante={variante}
      data-erstfokus={erstfokus ? '' : undefined}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
